import {
  HttpFetcher,
  HttpResponseError
} from "./HttpFetcher.js";
class HttpJsonFetcher extends HttpFetcher {
  // config.config/config.config.fetch를 직접 mutate하면(예전처럼) 같은 config 객체를 여러
  // postJson/patchJson/putJson 호출이 동시에 공유할 때 서로의 headers/body를 덮어쓰는 레이스가
  // 생긴다(HttpFetcher.get/post의 method 레이스랑 같은 문제). caller의 객체는 안 건드리고,
  // 얕은 복사본을 만들어서 새 config 객체를 리턴한다.
  updateJsonFetchConfigAndData(config) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json, text/plain, */*"
    };
    const fetchInit = { ...config.config?.fetch };
    const merged = new Headers(headers);
    if (fetchInit.headers) {
      new Headers(fetchInit.headers).forEach((value, key) => merged.set(key, value));
    }
    fetchInit.headers = merged;
    if (fetchInit.body && typeof fetchInit.body !== "string") {
      fetchInit.body = JSON.stringify(fetchInit.body);
    }
    return { ...config, config: { ...config.config, fetch: fetchInit } };
  }
  get(config) {
    return super.get(config);
  }
  delete(config) {
    return super.delete(config);
  }
  post(config) {
    return super.post(config);
  }
  patch(config) {
    return super.patch(config);
  }
  put(config) {
    return super.put(config);
  }
  head(config) {
    return super.head(config);
  }
  postJson(config) {
    return super.post(this.updateJsonFetchConfigAndData(config));
  }
  patchJson(config) {
    return super.patch(this.updateJsonFetchConfigAndData(config));
  }
  putJson(config) {
    return super.put(this.updateJsonFetchConfigAndData(config));
  }
  async errorTransform(e) {
    const httpResponseError = new HttpResponseError();
    httpResponseError.error = e;
    if (e instanceof Response) {
      httpResponseError.response = e;
      try {
        httpResponseError.body = await e.clone().json();
        httpResponseError.message = e.statusText;
      } catch (parseError) {
        httpResponseError.body = parseError;
        httpResponseError.message = parseError.message;
      }
    } else {
      httpResponseError.body = e;
      httpResponseError.message = e.message;
    }
    return httpResponseError;
  }
  // protected execute(target: HttpFetcherTarget, config?: HttpJsonFetcherConfig<C, any>): Promise<any> {
  execute(fetcherRequest) {
    return super.execute(fetcherRequest).then((response) => {
      const config = fetcherRequest.config;
      const transform = config?.responseTransform ?? (config?.bypassTransform ? "response" : config?.transformText ? "text" : void 0);
      if (transform === "response") {
        return response;
      } else if (transform === "text") {
        return response?.text();
      } else if (typeof transform === "function") {
        return transform(response);
      } else {
        return response?.text().then((it) => {
          if ((it ?? "").length > 0) {
            return JSON.parse(it);
          }
        });
      }
    });
  }
}
export {
  HttpJsonFetcher
};
//# sourceMappingURL=HttpJsonFetcher.js.map
